module.exports = __webpack_public_path__ + "img/c-1.e4a88b2a.png";